import { BaseHelper } from './BaseGraphQLAPIHelper';

export const getAppUpdate = () => {
  const query = `{
    appUpdate {
      iosLowestSupportingVersion
      androidLowestSupportingVersion
      forceUpdateTitle
      forceUpdateDescription
      optionalUpdateTitle
      optionalUpdateDescription
      translations {
        language
        forceUpdateTitle
        forceUpdateDescription
        optionalUpdateTitle
        optionalUpdateDescription
      }
    }
  }`;
  const variables = {};

  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateAppUpdate = (inputBody) => {
  const query = `
    mutation UpdateAppUpdate($input: UpdateAppUpdateInput!) {
      updateAppUpdate(input: $input) {
        success
      }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};
